(() => {
  'use strict';

  function initializeProduct(section) {
    if (section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';
    const form = section.querySelector('[data-product-form]');
    const purchaseEnabled = section.dataset.purchaseEnabled === 'true';
    const addButton = section.querySelector('[data-add-to-cart]');
    const currentPrice = section.querySelector('[data-current-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const errorMessage = section.querySelector('[data-product-error]');
    const statusMessage = section.querySelector('[data-product-status]');
    let pending = false;
    let lastVariantId = null;

    function showMedia(mediaId) {
      const frames = Array.from(section.querySelectorAll('[data-media-frame]'));
      if (!frames.some(frame => frame.dataset.mediaFrame === String(mediaId))) return;
      frames.forEach(frame => {
        const active = frame.dataset.mediaFrame === String(mediaId);
        const wasVisible = !frame.hidden;
        frame.hidden = !active;
        if (!active && wasVisible) {
          frame.querySelectorAll('video').forEach(video => video.pause());
          frame.querySelectorAll('iframe').forEach(iframe => {
            iframe.src = iframe.src;
          });
        }
      });
      section.querySelectorAll('[data-media-target]').forEach(button => {
        const active = button.dataset.mediaTarget === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    section.querySelectorAll('[data-media-target]').forEach(button => {
      button.addEventListener('click', () => showMedia(button.dataset.mediaTarget));
    });

    function selectedOption() {
      if (!form) return null;
      const selectedPackage = form.querySelector('[data-variant-option]:checked');
      const select = form.querySelector('[data-variant-select]');
      return selectedPackage || (select ? select.selectedOptions[0] : null);
    }

    function updateSelection() {
      const option = selectedOption();
      if (!option || !addButton) return;
      currentPrice.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
      form.querySelectorAll('.product-package').forEach(card => {
        const radio = card.querySelector('input');
        card.classList.toggle('is-selected', Boolean(radio && radio.checked));
      });
      const available = option.dataset.available === 'true';
      if (option.value !== lastVariantId) {
        const quantity = form.querySelector('input[name="quantity"][type="number"]');
        if (quantity) {
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          if (lastVariantId !== null) quantity.value = quantity.min;
        }
        lastVariantId = option.value;
      }
      addButton.disabled = pending || !purchaseEnabled || !available;
      addButton.textContent = pending ? 'Adding…' : !purchaseEnabled ? 'Coming soon' : available ? 'Add to cart' : 'Sold out';
      if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
    }

    if (!form) return;
    form.addEventListener('change', event => {
      if (!event.target.matches('[data-variant-option], [data-variant-select]')) return;
      errorMessage.hidden = true;
      statusMessage.textContent = '';
      updateSelection();
    });
    updateSelection();

    form.addEventListener('submit', async event => {
      event.preventDefault();
      const option = selectedOption();
      if (pending || !purchaseEnabled || !option || option.dataset.available !== 'true') return;
      if (!form.reportValidity()) return;
      const body = new FormData(form);
      body.delete('add');
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      pending = true;
      errorMessage.hidden = true;
      statusMessage.textContent = '';
      form.setAttribute('aria-busy', 'true');
      updateSelection();
      try {
        const response = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          body,
          headers: { Accept: 'application/json' }
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'This item could not be added. Please review the quantity and try again.');
        }
        statusMessage.textContent = 'Added to your cart.';
        if (section.dataset.checkoutAfterAdd === 'true') {
          window.location.assign(cartRoot + 'checkout');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { open: true, source: 'product', sectionId: section.dataset.sectionId }
        }));
      } catch (error) {
        errorMessage.textContent = error instanceof TypeError ? 'We could not confirm the cart update. Check your cart before trying again.' : error.message || 'We could not add this item. Please try again.';
        errorMessage.hidden = false;
      } finally {
        pending = false;
        form.removeAttribute('aria-busy');
        updateSelection();
      }
    });
  }

  function initializeWithin(root) {
    if (root.matches && root.matches('[data-product-section]')) initializeProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  }
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
